class DevTools extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.devLog = (message) => {
      return message;
    };

    if (document.querySelector("dev-tools").dataset.devLogs === "true") {
      window.devLog = (message, data) => {
        console.log(
          `%c${message}`,
          "color: #FFF; font-size: 14px; background: #000000; padding: 1rem;"
        );
        if (data) console.log(data);
      };
    }

    window.capitalize = (str) => str[0].toUpperCase() + str.substring(1);

    window.titleize = (str) => {
      let newStr = "";

      str
        .toLowerCase()
        .replaceAll(/[()]/g, "")
        .split("-")
        .forEach(
          (word, i) =>
            (newStr = newStr + (i === 0 ? "" : " ") + window.capitalize(word))
        );

      return newStr;
    };

    window.handleize = (str) => {
      str = str.trim(); // remove whitespace from string
      str = str.toLowerCase(); // Set to lowercase
      str = str.replace(/\s+/g, "-"); // Replace spaces
      str = str.replace(/&/g, "-"); // Replace ampersands
      str = str.replace(/----/g, "-"); // Replace four dashes
      str = str.replace(/---/g, "-"); // Replace triple dashes
      str = str.replace(/--/g, "-"); // Replace double dashes
      str = str.replace(/"/g, ""); // Removed double quotes
      return str;
    };

    window.underscoreFetch = (payload) => {
      return fetch(
        `https://${window.Shopify.shop}/api/${window.API_VERSION}/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/graphql",
            "X-Shopify-Storefront-Access-Token": window.API_ACCESS,
          },
          body: payload,
        }
      );
    };
  }
}

customElements.define("dev-tools", DevTools);
